import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import * as echarts from 'echarts';
import { computed, ref, watch } from 'vue';
export default {
  __name: 'ChartPie',
  props: {
    height: String,
    width: String,
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    name: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const contStyle = computed(() => ({
      height: props.height,
      width: props.width
    }));
    const chartCont = ref();
    watch(props.data, () => {
      render();
    });
    function render() {
      if (!chartCont.value) {
        return;
      }
      const chart = echarts.init(chartCont.value);
      chart.setOption({
        title: {
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        //
        // legend: {
        //   orient: 'vertical',
        //   right: 0,
        //   top: 'center'
        // },
        series: [{
          name: props.name,
          type: 'pie',
          radius: ['40%', '70%'],
          itemStyle: {
            borderRadius: 5
          },
          data: props.data || [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      });
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "chart",
        ref_key: "chartCont",
        ref: chartCont,
        style: _normalizeStyle(contStyle.value)
      }, null, 4);
    };
  }
};